import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { ErrorCatalogRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const ERROR_CATALOG_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const errorCatalogGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No failed transactions recorded for this terminal yet — nothing to map.</span>',
} satisfies GridOptions<ErrorCatalogRow>;
